import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ReactNode } from 'react';
import UnionLayout from '@xo-union/tk-component-layout';
import Header from '@xo-union/tk-component-header-nav-redux/remote';
import Footer from '@xo-union/tk-component-footer-nav/remote';
import dynamic from 'next/dynamic';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useIsMobileSize } from '@/app/helpers/useWindowSize';
import { PRODUCT_NAME } from '@/app/components/constants';
import loadMember from '@/redux/membership/loadMember';

const LeaderboardAd = dynamic(() => import('./LeaderboardAd'), { ssr: false });

type LayoutProps = {
  children: ReactNode;
  hideHeader?: boolean;
  hideFooter?: boolean;
  hideAds?: boolean;
};

const reactQueryClient = new QueryClient();
const showToolkit = process.env.SHOW_TANSTACK_TOOLKIT === 'true';

export const Layout = ({
  children,
  hideHeader = false,
  hideFooter = false,
  // Note: There is a requirement to hide ads on budget advisor
  hideAds = false,
}: LayoutProps): JSX.Element => {
  loadMember();

  const isMobile = useIsMobileSize();

  return (
    <UnionLayout
      header={
        !hideHeader && (
          <div>
            {!isMobile && !hideAds && <LeaderboardAd />}
            <Header
              activeProduct="planning-tools"
              metadata={{ applicationName: PRODUCT_NAME }}
              analyticsProps={{ product: PRODUCT_NAME }}
              loggedIn
              ssi
            />
          </div>
        )
      }
      footer={!hideFooter && <Footer analyticsProps={{ product: PRODUCT_NAME }} ssi />}
    >
      <main id="layoutContent" style={{ width: '100%', minWidth: '200px' }}>
        <QueryClientProvider client={reactQueryClient}>
          {children}
          {showToolkit && <ReactQueryDevtools initialIsOpen={false} position="top-right" />}
        </QueryClientProvider>
      </main>
    </UnionLayout>
  );
};
